
import React from 'react'
import Sidenav from '../components/Sidenav'
import CakeProducts from '../components/products/CakeProducts'
import Addcake from '../components/products/Addcake'

export default function Cakeproduct() {
  return (
   <div className="flex flex-1 ">
       <div className="">
       <Sidenav />
       </div>
        <div className="mt-24">
        <Addcake />

            <CakeProducts />
        </div>
    </div>    )
}
